export enum TableType {
  SIMPLE = 'SIMPLE',
  PAGINATED = ' PAGINATED',
}
